(function () {
    'use strict';

    angular
        .module('signalrControllers')
        .controller('ChatController', Controller);

    Controller.$inject = ['$scope', 'ChatService', 'authenticatedUser'];

    function Controller($scope, ChatService, authenticatedUser) {

        $scope.chats = ChatService;
        $scope.username = authenticatedUser.MetaDataUser.DisplayName;
        $scope.iconUrl = authenticatedUser.MetaDataUser.UrlImage;
        $scope.sendChat = function () {
            $scope.chats.send($scope.username, $scope.iconUrl, $scope.message);
            $('#message').val('').focus();
        }
    }
})();